import React from "react";

export default function BreadcrumbSection() {
	return (
		<div className="fugu--breadcrumbs-section">
			<div className="fugu--breadcrumbs-data center-content">
				<h1>Meet our creative team</h1>
				<p>
					Meet our expert team who value these relationships. A creative workplace gives the ability to come
					up with unique solutions to challenges of simply being told what to do.
				</p>
			</div>
		</div>
	);
}
